import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEdit,
    faPlus,
    faSort,
    faTrash,
    faPenToSquare,
    faTimes,
  } from "@fortawesome/free-solid-svg-icons";
import clientDemoImg from "../assets/img/EmptyLogo.png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import ReactDOM from "react-dom";
import { commonAPI } from "../services/CommonAPIService";
import Menus from "./menus";
// import { Wizard, Steps, Step, WithWizard } from "react-multistep-wizard";
// import SlideButton from "react-slide-button";
import { Stepper, Step, StepLabel } from "@mui/material";
// import  clientimg  from '../assets/img/clientimg.jpg';
// import  clientimg2  from '../assets/img/clientimg-2.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import INDFlag from "../assets/img/INDFlag.jpg";
import filepreview from '../assets/img/filepreview.png';
import Table from 'react-bootstrap/Table'; 
import { ErrorSource } from "../common/constants";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
 import switchBaseClasses from "@mui/material/internal/switchBaseClasses";
 import { styled } from '@mui/material/styles';
 import FormGroup from '@mui/material/FormGroup';
 import FormControlLabel from '@mui/material/FormControlLabel';
 import noticeuserupload from '../assets/img/noticeuserupload.png';
 import Switch, { SwitchProps } from '@mui/material/Switch';
 import Stack from '@mui/material/Stack';
 import Typography from '@mui/material/Typography';
 import JoditEditor from 'jodit-react';
 import Form from 'react-bootstrap/Form';
 import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
 
 
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';


function EmailTemplate() {
    const [fullscreen, setFullscreen] = useState(true);
    const [activeStep, setActiveStep] = useState(0);
    const steps = ["Step 1", "Step 2", "Step 3"];
    const [show, setShow] = useState(false);
    const [showFirstModal,setShowFirstModal] = useState(false)
    const [Loading, setLoading] = useState(false);
    const [NoticeList, setNoticeList] = useState("");
    const [NoticeSubject, setNoticeSubject] = useState("");
    const [NoticeDescription, setNoticeDescription] = useState("");
    const [NoticeEmail, setNoticeEmail] = useState();
    const [NoticeId, setNoticeId] = useState();
    const [Importance, setImportance] = useState();
    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [NoticeType, setNoticeType] = useState("");
    const [NoticeTypeId, setNoticeTypeId] = useState();
    const [NoticeTypeText, setNoticeTypeText] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImageShow, setSelectedImageShow] = useState(null);
    const [selectedImageTwo, setSelectedImageTwo] = useState(null);
    const [selectedImageTwoShow, setSelectedImageTwoShow] = useState(null);
    const [firstSectionButton, setFirstSectionButton] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddNoticeBtn, setAddNoticeBtn] = useState(false);
    const [UpdateNoticeBtn, setUpdateNoticeBtn] = useState(false);


    const openCreateModal = () => {
        setShow(true);
        setAddNoticeBtn(true);
        setUpdateNoticeBtn(false);
        setNoticeSubject("");
        setNoticeDescription("");
        setNoticeEmail("");
        setImportance("");
        setStartDate("");
        setEndDate("");
        setSelectedImage("");
        setSelectedImageTwo("");
      };

      const openCreateModalagain = () => {
        setShowFirstModal(true);
        setAddNoticeBtn(true);
        setUpdateNoticeBtn(false);
        setNoticeSubject("");
        setNoticeDescription("");
        setNoticeEmail("");
        setImportance("");
        setStartDate("");
        setEndDate("");
        setSelectedImage("");
        setSelectedImageTwo("");
      };

      const editor = useRef(null);
      const [content, setContent] = useState('');
      const handleFileInputChangeTwo = (event) => {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            const encodedString = btoa(reader.result);
            setSelectedImageTwo(reader.result);
            setSelectedImageTwoShow(encodedString);
          };
          reader.readAsDataURL(file);
        }
      };    

 

      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

      const [state, setState] = React.useState({
        gilad: true,
        jason: false,
        antoine: false,
      });
    
      const handleChange = (event) => {
        setState({
          ...state,
          [event.target.name]: event.target.checked,
        });
      };
    
      const { DLF, Magnolias, Bestech ,Kraheja } = state;
      const error = [DLF, Magnolias, Bestech ,Kraheja].filter((v) => v).length !== 2;
    
  return (
    <> 

<div className="row mb-1" style={{ alignItems:'center'}}>
        <div className="col-md-4 mt-5 pt-2">
          <div className="HeadingTop">
            <h3> SMS Template   </h3>
            <span> List of Curo Solution Email Template</span>
          </div>
        </div>
        <div className="col-md-3 mt-5 offset-md-5 text-right">
        {/* <Button  onClick={() => openCreateModalagain()} className="createClr">
            {" "}
            Copy Settings <FontAwesomeIcon icon={faCopy} />
          </Button>{" "}
          <Button onClick={() => openCreateModal()} className="createClr">
            {" "}
            Create New +
          </Button>{" "} */}
        </div>
      </div>
      <div className="row mb-3" style={{ alignItems:'center' }}>
             <div className="col-lg-12 col-md-12 col-sm-12 col-12">
             <div className="tableFixHead">
              <div className="scrolling_tbl" style={{height: 140}}>
              <Table striped responsive="lg">
          <thead>
            <tr>
              
              <th>Template Type</th>
              <th>Template Name</th>
              <th>Sms Text</th>
              <th>Status</th>
              <th>Edit</th>
              {/* <th>Delete</th> */}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Airtel</td>
              <td>8081</td>
              <td><Link>View</Link></td>
              <td>Active</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
              {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
            </tr>
            <tr>
              <td>Airtel</td>
              <td>8081</td>
              <td><Link>View</Link></td>
              <td>Active</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
              {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
            </tr>
            <tr>
              <td>Airtel</td>
              <td>8081</td>
              <td><Link>View</Link></td>
              <td>Inactive</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
              {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
            </tr>
            <tr>
              <td>Airtel</td>
              <td>8081</td>
              <td><Link>View</Link></td>
              <td>Inactive</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
              {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
            </tr>
            <tr>
              <td>Airtel</td>
              <td>8081</td>
              <td><Link>View</Link></td>
              <td>Inactive</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
            {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
          </tr>
          <tr>
            <td>Airtel</td>
              <td>8081</td>
              <td><Link>View</Link></td>
              <td>Active</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
            {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
          </tr>
          <tr>
            <td>Airtel</td>
            <td>8081</td>
            <td><Link>View</Link></td>
            <td>Active</td>
            <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
            {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
          </tr>
          <tr>
            <td>Airtel</td>
            <td>8081</td>
            <td><Link>View</Link></td>
            <td>Active</td>
            <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
            {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
          </tr>
          </tbody>

        </Table>
        
              </div>
            </div>  

      <div className="table_ntr mt-2">
        <div className="col-12 p-0">
          <label>Sms Text</label>
          {/* <input placeholder='RouteID' type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" /> */}
          <textarea  class="form-control required textAreaHeight"/>
        </div>
        
        
      </div>
      <div className="table_ntr">
        <div className="col-2 pl-0">
          <label>Template Type</label>
          <select size="sm" className="sltareamodal  ml-auto"  style={{height: "30px"}}>
            <option value="Approved">Active</option>
            <option value="Denied"> Inactive </option> 
          </select>
        </div> 
        <div className="col-2">
          <label>Template Name</label> 
          <input  type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
        </div>  
        <div className="col-8 pr-0" style={{textAlign: "end"}}>
          <Button  onClick={() => openCreateModalagain()} className="createClr bg-secondary tempMargin" style={{height: "30px" , width: 75}}>
            {" "} Cancel
          </Button>{" "} 
          <Button  onClick={() => openCreateModalagain()} className="createClr tempMargin" style={{height: "30px", width: 75}}>
            {" "}<FontAwesomeIcon icon={faPlus} /> Add  
          </Button>{" "} 
        </div>  
      </div>
      
      

      <div className="table_ntr mt-2">
        
      </div>

      {/* <div className="table_ntr mt-2" style={{justifyContent: "end"}}>
        <Button  onClick={() => openCreateModalagain()} className="createClr bg-secondary" style={{height: "30px"}}>
          {" "}    Cancel
        </Button>{" "} 
        <Button  onClick={() => openCreateModalagain()} className="createClr" style={{height: "30px"}}>
          {" "}<FontAwesomeIcon icon={faPlus} />    Add  
        </Button>{" "}
      </div> */}

             </div>
        </div>

      <Modal  size="sm" show={showFirstModal}
        onHide={() => setShowFirstModal(false)}>
        <Modal.Header className="headerMDL" closeButton>
          <Modal.Title onClick={openCreateModalagain}>Sms Template</Modal.Title>
        </Modal.Header>
        <Modal.Body> 
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
            <span>Building </span> 
            </div>
            <div className="col-lg-9 col-md-9 col-sm-12 col-12">
            <div className="subPopup">

<select size="md" className="sltareamodal col-12 ml-auto"  >
        <option value="Geeral">Building 1</option>
        <option value="Alert"> Building 2</option>
        <option value="Warning">Building 3</option>
         
    </select>
</div>
</div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
 <span className="eT_sub"> Email Templates</span>
        <FormGroup>
               <FormControlLabel control={<Checkbox checked={DLF} defaultChecked color="success" onChange={handleChange} name="DLF" />}
            label="Email Template 1" />
              <FormControlLabel control={<Checkbox checked={Magnolias} defaultChecked color="success" onChange={handleChange} name="Magnolias" />}
            label="Email Template 2" />
               <FormControlLabel control={<Checkbox checked={Bestech} defaultChecked color="success" onChange={handleChange} name="Bestech" />}
            label="Email Template 3" />
               <FormControlLabel control={<Checkbox checked={Kraheja} defaultChecked color="success" onChange={handleChange} name="Kraheja" />}
            label="Email Template 4" />
        </FormGroup>
               </div>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Copy Settings
          </Button>
        </Modal.Footer>
      </Modal>
 
      <Modal scrollable
        fullscreen={fullscreen}
        show={show}
        onHide={() => setShow(false)}
        dialogclassName="modal-100w clientmodal"
        class="modal-dialog modal-fullscreen"
      >
        <Modal.Header className="headerMDL" closeButton>
          <Modal.Title onClick={openCreateModal}>Email Template</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row" id="validation">
            <div className="col-12">
              <form
                action="#"
                className="validation-wizard wizard-circle wizard clearfix"
                role="application"
                id="steps-uid-0"
                novalidate="novalidate"
              >
 
                <div>

                    <div className="row">
                    <div className="col-lg-9 col-md-9 col-sm-12 col-12">
                         <div className="row">
                         <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  Template Type {" "}
                                  <span className="danger">*</span>{" "}
                                </label>
                                <select size="md" className="sltareamodal col-12 ml-auto"  >
                        <option value="Geeral">General</option>
                        <option value="Alert">Alert</option>
                        <option value="Warning">Warning</option>
                         
                    </select>
                          
                            </div>
                                       </div>
                         <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  Template Name {" "}
                                  <span className="danger">*</span>{" "}
                                </label>
                                <input type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
                            </div>
                                       </div>
                                       <div class="col-lg-4 col-md-4 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  To Recipient {" "}
                                  <span className="danger">*</span>{" "}
                                </label>
                                <input type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
                          
                            </div>
                                       </div>


                                       <div class="col-lg-4 col-md-4 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  CC Recipient {" "}
                                  <span className="danger">*</span>{" "}
                                </label>
                                <input type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
                          
                            </div>
                                       </div>
                         <div class="col-lg-4 col-md-4 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  BCC Recipient {" "}
                                  <span className="danger">*</span>{" "}
                                </label>
                                <input type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
                          
                            </div>
                                       </div>
                                   
                                       <div class="col-lg-3 col-md-3 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  Email Signature {" "} 
                                </label>
                                <input type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
                          
                            </div>
                                       </div>
                      


                                       <div class="col-lg-3 col-md-3 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  Attach File {" "} 
                                </label>
                                <input type="file" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
                          
                            </div>
                                       </div>
                                       <div class="col-lg-3 col-md-3 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  File Extensions {" "} 
                                </label>
                                <input type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
                          
                            </div>
                                       </div>
                                       <div class="col-lg-3 col-md-3 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  High Importance {" "} 
                                </label>
                                <select size="md" className="sltareamodal col-12 ml-auto"  >
 
                        <option value="Geeral">Yes</option>
                        <option value="Alert">No </option> 
                    </select>
                          
                            </div>
                                       </div>                                   
                                   
                                       <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  Subject {" "}
                                  <span className="danger">*</span>{" "}
                                </label>
                                <input type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
                          
                            </div>
                                       </div>

 

                                       <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
                              
                              <div className="form-group">
                                <label for="wfirstName2">
                                  {" "}
                                  Email Body {" "}
                                  <span className="danger">*</span>{" "}
                                </label>
                                <JoditEditor ref={editor} value={content} tabIndex={1} onBlur={newContent => setContent(newContent)}/>
                          
                            </div>
                                       </div>



                                       <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                       <button type="button" className="btn btn-info createClr"> Cancel</button>
                                       <button type="button" className="btn btn-info createClr"> Submit</button>
                                    
                                       </div>
                         </div>


                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 border_areaFullwdth">
                             <div className="form-group">
                            
                            <img src={filepreview} className="img img-responsive"/>

                            <h6 onChange={(e)=>handleFileInputChangeTwo(e)}>Email Preview</h6>

                                                        
   
                        </div>
                        </div>
 
                    </div>



                 
      
                </div>
              </form>
            </div>
          </div>

        </Modal.Body>
 
      </Modal>
      
</>
  );
}
export default EmailTemplate;
